enum EnquiryType {
    Unknown = 0,
    Website = 1,
    Email = 2,
    Phone = 3,
    BgLiveChat = 4,
    EmailPersonal = 5,
    Event = 6,
    Internal = 7,
    Letter = 8,
    Meeting = 9,
    PhonePersonal = 10,
    SocialMedia = 11,
    SurveyMonkey = 12,
    Walkin = 13
}

export { EnquiryType };